import React, { useState } from "react";
import FacebookLogin, { ReactFacebookLoginInfo } from "react-facebook-login";
import { useNavigate } from "react-router-dom";
import AuthenticationRequest from "../../api/requests/AuthenticationRequest";
import LoginProvider from "../../api/enums/LoginProvider";
import AuthClient from "../../api/AuthClient";
import { useLoading } from "../Loader/LoadingContext";
import { getFacebookAvatar } from "../../utils/utils";
import { localStorageKeys } from "../../utils/localStorageKeys";
import { routes } from "../../routes/routes";
import styles from "./facebook.module.scss";
import "../Login/socialLoginButtons.css";
import { FacebookLoginAppId } from "../../utils/constants";
import { Modal } from "react-bootstrap";
import { handleApiError } from "../../api/handleApiErrors";
import { getPostLoginRouteForUser } from "../../utils/appMode";

export default function FacebookLoginButton() {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [error, setError] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const facebookLoginCallback = async (response: ReactFacebookLoginInfo) => {
    setLoading(true);
    try {
      const [firstName, lastName] = response.name !== undefined ? response.name.split(' ') : ['', ''];
      const asJson = JSON.parse(JSON.stringify(response));

      const request: AuthenticationRequest = {
        loginProvider: LoginProvider.Facebook,
        authenticationProviderResponse: {
          firstName: firstName,
          lastName: lastName,
          email: response.email,
          picture: {
            url: response.picture?.data.url,
          },
          externalUserId: response.userID,
          accessToken: response.accessToken,
          expiresIn: asJson['expiresIn'],
        },
      };

      const auth: AuthClient = new AuthClient();
      localStorage.setItem(localStorageKeys.userImg, getFacebookAvatar(response.id));

      const authResponse = await auth.authenticate(request);
      if (authResponse?.data) {
        navigate(getPostLoginRouteForUser(authResponse.data.userType));
        return;
      }

      navigate(routes.Root);
    } catch (err) {
      const isHandled = handleApiError(err, setError);
      if (isHandled) {
        handleShow();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FacebookLogin
        appId={FacebookLoginAppId}
        autoLoad={false}
        fields="name,email,picture"
        callback={facebookLoginCallback}
        textButton="Log In with Facebook"
        icon="fa-facebook"
        cssClass='loginBtn loginBtn--facebook'
        disableMobileRedirect = {true}
      />
      <Modal show={showModal} backdrop={false} dialogClassName={styles.centeredModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{error}</Modal.Body>
      </Modal>
    </>
  );
}
